<div class="incident-links-tab">
    <div class="link-section">
        <div class="section-title">Linked Risks</div>
        <div class="linked-risks">
            @if (risks.length === 0) {
                <div class="linked-risks-none" data-uiid="incident-linked-risks-none-label">Link an item to display</div>
            }
            @for (risk of risks; track risk; let i = $index) {
                <div class="linked-risk">
                    <div class="linked-risk-title" [attr.data-uiid]="'incident-linked-risks-' + i + '-title'">
                        <span class="linked-risk-identifier">
                            {{ (risk.identifier | number: "8.0-0").replaceAll(",", "") }}
                        </span>
                        |
                        {{ risk.name }}
                    </div>
                    <div class="linked-risk-buttons">
                        <cerrix-icon-button
                            [dataUiid]="'incident-linked-risks-' + i + '-open-button'"
                            color="accent-link"
                            size="small"
                            (click)="openRisk(risk)"
                        >
                            <mat-icon fontSet="material-symbols-outlined">open_in_new</mat-icon>
                        </cerrix-icon-button>
                        @if (canEditIncident) {
                            <cerrix-icon-button
                                color="accent-link"
                                size="small"
                                [dataUiid]="'incident-linked-risks-' + i + '-unlink-button'"
                                (click)="unlinkRisk(risk.id)"
                            >
                                <mat-icon fontSet="material-symbols-outlined">link_off</mat-icon>
                            </cerrix-icon-button>
                        }
                    </div>
                </div>
            }
        </div>
        @if (canEditIncident) {
            <div class="linked-risk-footer">
                <cerrix-button
                    color="accent"
                    type="flat"
                    size="small"
                    [dataUiid]="'incident-linked-risks-link-button'"
                    (click)="openEditLinksPopup('risks')"
                >
                    <mat-icon>link</mat-icon>
                    Link Risks
                </cerrix-button>
            </div>
        }
    </div>

    <div class="link-section">
        <div class="section-title">Linked Controls</div>
        <div class="linked-risks">
            @if (controls.length === 0) {
                <div class="linked-risks-none" data-uiid="incident-linked-controls-none-label">Link an item to display</div>
            }
            @for (control of controls; track control; let i = $index) {
                <div class="linked-risk">
                    <div class="linked-risk-title" [attr.data-uiid]="'incident-linked-controls-' + i + '-title'">
                        <span class="linked-risk-identifier">
                            {{ (control.identifier | number: "8.0-0").replaceAll(",", "") }}
                        </span>
                        |
                        {{ control.name }}
                    </div>
                    <div class="linked-risk-buttons">
                        <cerrix-icon-button
                            color="accent-link"
                            size="small"
                            [dataUiid]="'incident-linked-controls-' + i + '-open-button'"
                            (click)="openControl(control)"
                        >
                            <mat-icon fontSet="material-symbols-outlined">open_in_new</mat-icon>
                        </cerrix-icon-button>
                        @if (canEditIncident) {
                            <cerrix-icon-button
                                color="accent-link"
                                size="small"
                                [dataUiid]="'incident-linked-controls-' + i + '-unlink-button'"
                                (click)="unlinkControl(control.id)"
                            >
                                <mat-icon fontSet="material-symbols-outlined">link_off</mat-icon>
                            </cerrix-icon-button>
                        }
                    </div>
                </div>
            }
        </div>
        @if (canEditIncident) {
            <div class="linked-risk-footer">
                <cerrix-button
                    color="accent"
                    type="flat"
                    size="small"
                    [dataUiid]="'incident-linked-controls-link-button'"
                    (click)="openEditLinksPopup('controls')"
                >
                    <mat-icon>link</mat-icon>
                    Link Controls
                </cerrix-button>
            </div>
        }
    </div>

    <div class="link-section">
        <div class="section-title">Linked Mois</div>
        <div class="linked-risks">
            @if (mois.length === 0) {
                <div class="linked-risks-none" data-uiid="incident-linked-mois-none-label">Create or link an item to display</div>
            }
            @for (moi of mois; track moi; let i = $index) {
                <div class="linked-risk">
                    <div class="linked-risk-title" [attr.data-uiid]="'incident-linked-mois-' + i + '-title'">
                        <span class="linked-risk-identifier">
                            {{ (moi.identifier | number: "8.0-0").replaceAll(",", "") }}
                        </span>
                        |
                        {{ moi.name }}
                    </div>
                    <div class="linked-risk-buttons">
                        <cerrix-icon-button
                            color="accent-link"
                            size="small"
                            [dataUiid]="'incident-linked-mois-' + i + '-open-button'"
                            (click)="openMoi(moi)"
                        >
                            <mat-icon fontSet="material-symbols-outlined">open_in_new</mat-icon>
                        </cerrix-icon-button>
                        @if (canEditIncident) {
                            <cerrix-icon-button
                                color="accent-link"
                                size="small"
                                [dataUiid]="'incident-linked-mois-' + i + '-unlink-button'"
                                (click)="deleteMoi(moi)"
                            >
                                <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
                            </cerrix-icon-button>
                        }
                    </div>
                </div>
            }
        </div>
        @if (canEditIncident && !hideCreateMoi) {
            <div class="linked-risk-footer">
                <cerrix-button
                    color="accent"
                    type="flat"
                    size="small"
                    [dataUiid]="'incident-linked-mois-create-new-button'"
                    (click)="createMoi()"
                >
                    <mat-icon>add</mat-icon>
                    Create MoI
                </cerrix-button>
            </div>
        }
    </div>
    @if (showAssets) {
        <div class="link-section">
            <div class="section-title">Linked Assets</div>
            <div class="linked-risks">
                @if (assets.length === 0) {
                    <div class="linked-risks-none">Link an item to display</div>
                }
                @for (asset of assets; track asset; let i = $index) {
                    <div class="linked-risk">
                        <div class="linked-risk-title">
                            <span class="linked-risk-identifier">{{ asset.identifier }}</span>
                            |
                            {{ asset.name }}
                        </div>
                        <div class="linked-risk-buttons">
                            <cerrix-icon-button
                                color="accent-link"
                                size="small"
                                [dataUiid]="'incident-linked-assets-' + i + '-open-button'"
                                (click)="openAsset(asset)"
                            >
                                <mat-icon fontSet="material-symbols-outlined">open_in_new</mat-icon>
                            </cerrix-icon-button>
                            @if (canEditIncident) {
                                <cerrix-icon-button
                                    color="accent-link"
                                    size="small"
                                    [dataUiid]="'incident-linked-assets-' + i + '-unlink-button'"
                                    (click)="unlinkAsset(asset.id)"
                                >
                                    <mat-icon fontSet="material-symbols-outlined">link_off</mat-icon>
                                </cerrix-icon-button>
                            }
                        </div>
                    </div>
                }
            </div>
            @if (canEditIncident) {
                <div class="linked-risk-footer">
                    <cerrix-button
                        color="accent"
                        type="flat"
                        size="small"
                        [dataUiid]="'incident-linked-assets-link-button'"
                        (click)="openEditLinksPopup('assets')"
                    >
                        <mat-icon>link</mat-icon>
                        Link Assets
                    </cerrix-button>
                </div>
            }
        </div>
    }
</div>
